<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="name"
                    name="name"
                    label="Name"
                    :counter="50"
                    v-validate="'required|max:50'"
                    data-vv-as="Name"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-btn color="info" type="button" @click="imagePicked">
                    <v-icon>cloud_upload</v-icon>Pdf
                  </v-btn>
                  <input
                    type="file"
                    style="display: none"
                    ref="ImageUploader"
                    accept="application/pdf"
                    @change="onImagePicked"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <embed
                    :src="attachment"
                    style="width:100%"
                    v-if="attachment"
                  />
                  <!-- <img :src="attachment" style="width:100%" v-if="attachment" /> -->
                </v-flex>
              </v-layout>
            </v-container>

            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from "../../store";
import commonservice from "../../shared/common.service";
export default {
  computed: {
    name: {
      get() {
        return this.$store.state.contentAttachment.entity.name;
      },
      set(val) {
        this.$store.commit("contentAttachment/SET_CONTENT_ATTACHMENT_DATA", {
          key: "name",
          value: val
        });
      }
    },
    attachment: {
      get() {
        return this.$store.state.contentAttachment.entity.attachment;
      },
      set(val) {
        this.$store.commit("contentAttachment/SET_CONTENT_ATTACHMENT_DATA", {
          key: "attachment",
          value: val
        });
      }
    }
  },
  data() {
    return {
      pageTitle: "Add Content Attachment",
      loading: false,
      menu: false,
      menu1: false
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store
        .dispatch("contentAttachment/setContentAttachment", {
          id: to.params.id
        })
        .then(() => {
          next(p => {
            p.pageTitle = "Edit Content Attachment";
          });
        });
    } else {
      if (store.state.contentAttachment.entity.contentId) {
        next(p => {
          p.reset();
        });
      } else {
        next("/content");
      }
    }
  },
  methods: {
    submit() {
      if (this.loading) return;
      if (this.attachment == null) {
        commonservice.showErrorMessage("Please upload attachment");
        return;
      }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("contentAttachment/save")
            .then(
              () => {
                commonservice.showSuccessMessage(
                  "Attachment saved successfully"
                );
                this.$router.push("/contentAttachment");
                this.loading = false;
              },
              () => {
                this.loading = false;
              }
            )
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    reset() {
      this.$store.commit("contentAttachment/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    },
    imagePicked() {
      this.$refs.ImageUploader.click();
    },
    onImagePicked(event) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      var self = this;
      reader.onload = function() {
        self.$store.commit("contentAttachment/SET_CONTENT_ATTACHMENT_DATA", {
          key: "attachment",
          value: ""
        });
        setTimeout(() => {
          self.$store.commit("contentAttachment/SET_CONTENT_ATTACHMENT_DATA", {
            key: "attachment",
            value: reader.result
          });
        }, 50);
      };
    }
  }
};
</script>
